import { Form, Input } from "antd";
import { RoadNameAddress } from "./roadNameAddress";

const SearchAddress = () => {
  return (
    <>
      <Form.Item
        name="roadNameAddress"
        label="장소"
        valuePropName="roadNameAddress"
      >
        <RoadNameAddress />
      </Form.Item>

      <Form.Item name="locationName" label={true}>
        <Input maxLength={250} placeholder="상세 주소 입력" />
      </Form.Item>
    </>
  );
};

export default SearchAddress;
